var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20033",
    "data-name": "Grupo 20033",
    transform: "translate(-379 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1843",
    "data-name": "Rect\\xE1ngulo 1843",
    transform: "translate(379 55)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19810",
    "data-name": "Grupo 19810",
    transform: "translate(387 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Elipse_221",
    "data-name": "Elipse 221",
    d: "M8.491,2.123a6.368,6.368,0,1,0,6.368,6.368A6.375,6.375,0,0,0,8.491,2.123M8.491,0A8.491,8.491,0,1,1,0,8.491,8.491,8.491,0,0,1,8.491,0Z",
    transform: "translate(0 0)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_387",
    "data-name": "L\\xEDnea 387",
    d: "M5.183,6.245a1.058,1.058,0,0,1-.75-.311L-.689.812a1.061,1.061,0,0,1,1.5-1.5L5.934,4.433a1.061,1.061,0,0,1-.75,1.812Z",
    transform: "translate(12.821 14.451)",
    fill: "#777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.204ee6620fcb199c4fbd2e22ddbab85b.svg";
export { ForwardRef as ReactComponent };